import { api } from "./api";
import compressImage from "@/utils/compressImage";
const uploadApi = api.injectEndpoints({
  endpoints: builder => ({
    uploadImage: builder.mutation({
      queryFn: async ({
        file,
        folder,
        entityType,
        resourceId
      }, _api, _extra, baseQuery) => {
        const compressed = await compressImage(file);
        const form = new FormData();
        form.append("file", compressed);
        const params = new URLSearchParams();
        if (folder) params.set("folder", folder);
        if (entityType) params.set("entityType", entityType);
        if (resourceId) params.set("resourceId", resourceId);
        const url = `/upload/image${params.toString() ? `?${params.toString()}` : ""}`;
        const result = await baseQuery({
          url,
          method: "POST",
          body: form
        });
        if (result.error) return {
          error: result.error
        };
        return {
          data: result.data
        };
      }
    }),
    uploadProfileImage: builder.mutation({
      query: file => {
        const form = new FormData();
        form.append("file", file);
        return {
          url: "/upload/profile-image",
          method: "POST",
          body: form
        };
      },
      invalidatesTags: ["Users"]
    }),
    deleteProfileImage: builder.mutation({
      query: () => ({
        url: "/upload/profile-image",
        method: "DELETE"
      }),
      invalidatesTags: ["Users"]
    }),
    uploadFile: builder.mutation({
      query: ({
        file,
        folder
      }) => {
        const form = new FormData();
        form.append("file", file);
        return {
          url: `/upload/file${folder ? `?folder=${encodeURIComponent(folder)}` : ""}`,
          method: "POST",
          body: form
        };
      }
    })
  })
});
export const {
  useUploadImageMutation,
  useUploadProfileImageMutation,
  useDeleteProfileImageMutation,
  useUploadFileMutation
} = uploadApi;